import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const MarkdownRenderer = ({ content }) => {
  if (!content) return null;

  const lines = content.split("\n");
  const elements = [];
  let key = 0;

  lines.forEach((line) => {
    const trimmedLine = line.trim();

    if (!trimmedLine) {
      // Empty line - add spacing
      elements.push(<Box key={key++} sx={{ height: 8 }} />);
      return;
    }

    if (trimmedLine.startsWith("### ")) {
      // Title (h3)
      const title = trimmedLine.substring(4);
      elements.push(
        <Typography
          key={key++}
          variant="h6"
          fontWeight="bold"
          sx={{ mt: 2, mb: 1, color: "primary.main" }}
        >
          {title}
        </Typography>
      );
    } else if (
      trimmedLine.startsWith("**") &&
      trimmedLine.endsWith("**") &&
      trimmedLine.length > 4
    ) {
      // Subtitle (bold text)
      const subtitle = trimmedLine.substring(2, trimmedLine.length - 2);
      elements.push(
        <Typography
          key={key++}
          variant="subtitle1"
          fontWeight="bold"
          sx={{ mt: 1.5, mb: 0.5, color: "text.primary" }}
        >
          {subtitle}
        </Typography>
      );
    } else if (trimmedLine.startsWith("- ")) {
      // Bullet point
      const bulletText = trimmedLine.substring(2);
      elements.push(
        <Box
          key={key++}
          sx={{ display: "flex", alignItems: "flex-start", mb: 0.5, ml: 1 }}
        >
          <Typography
            variant="body2"
            sx={{ mr: 1, color: "primary.main", fontWeight: "bold" }}
          >
            •
          </Typography>
          <Typography variant="body2" sx={{ flex: 1 }}>
            {bulletText}
          </Typography>
        </Box>
      );
    } else {
      // Regular text
      elements.push(
        <Typography
          key={key++}
          variant="body2"
          sx={{ mb: 0.5, lineHeight: 1.6 }}
        >
          {trimmedLine}
        </Typography>
      );
    }
  });

  return <Box>{elements}</Box>;
};

MarkdownRenderer.propTypes = {
  content: PropTypes.string,
};

export default MarkdownRenderer;
